import {Pipe, Injectable, PipeTransform} from "@angular/core";
/**
 * Created by nijin on 2/1/17.
 */
@Pipe({
  name: 'schema',
})
export class SchemaFilterPipe implements PipeTransform {
  transform(items: any[], args): any {
    // filter items array, items which match and return true will be kept, false will be filtered out
    return items.filter(item => item.category.id === args.id);
  }
}



// WEBPACK FOOTER //
// ./src/app/schema/schema.filter.ts